import { SVGAttributes } from 'react'

const NavigateDownIcon = (props: SVGAttributes<SVGElement>) => (
    <svg fill={props.color || 'white'} viewBox="0 0 20 12" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 3.00439C20 3.09224 19.961 3.18009 19.8829 3.26794L10.3075 11.8946C10.2229 11.9649 10.122 12 10.0049 12C9.88775 12 9.78689 11.9649 9.70229 11.8946L0.126892 3.26793C0.0422972 3.19766 -1.3587e-07 3.10835 -1.31134e-07 3C-1.26398e-07 2.89165 0.0422972 2.80234 0.126892 2.73206L3.04539 0.105417C3.12348 0.0351384 3.22271 -7.33359e-07 3.34309 -7.28096e-07C3.46348 -7.22834e-07 3.56271 0.0351385 3.6408 0.105417L10.0049 5.83309L16.369 0.105418C16.447 0.035139 16.5463 -1.50967e-07 16.6667 -1.45705e-07C16.7871 -1.40442e-07 16.8863 0.035139 16.9644 0.105418L19.8829 2.73206C19.961 2.81991 20 2.91069 20 3.00439Z"
        />
    </svg>
)
export default NavigateDownIcon
